export const getUserDeviceInfo = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  return {
    browser: getBrowser(userAgent),
    device: getDevice(platform),
    lastAccessTime: new Date().toISOString(),
  };
};

const getBrowser = (userAgent) => {
  if (userAgent.indexOf("Chrome") > -1) {
    return "Chrome";
  } else if (userAgent.indexOf("Firefox") > -1) {
    return "Firefox";
  } else if (userAgent.indexOf("Safari") > -1) {
    return "Safari";
  } else if (userAgent.indexOf("Edge") > -1) {
    return "Edge";
  } else if (
    userAgent.indexOf("MSIE") > -1 ||
    userAgent.indexOf("Trident") > -1
  ) {
    return "Internet Explorer";
  }
  return "Unknown";
};

const getDevice = (platform) => {
  if (/Mobi|Android/i.test(platform)) {
    return "Mobile";
  } else if (/Tablet|iPad/i.test(platform)) {
    return "Tablet";
  }
  return "Desktop";
};
